import axios from '@/axios-auth'

const state = {
  contractPartners: [],
  contractPartner: {}
}

const getters = {
  contractPartners: state => state.contractPartners,
  contractPartner: state => state.contractPartner
}

const actions = {
  fetchContractPartners ({getters, commit, dispatch}) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/contractPartnerTemplates`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setContractPartners', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  storeContractPartner ({getters, commit, dispatch}, contractPartner) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.post(`/contractPartners`, contractPartner, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('addContractPartner', response.data)
        dispatch('setLogoutTimer')
        resolve(response.data)
      }).catch((err) => reject(err))
    })
  },
  updateContractPartner ({commit, dispatch, getters}, contractPartner) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.put(`/contractPartners/${contractPartner.id}`, contractPartner, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  }
}

const mutations = {
  addContractPartner (state, contractPartner) {
    state.contractPartners.push(contractPartner)
  },
  setContractPartners (state, contractPartners) {
    state.contractPartners = contractPartners
  },
  setContractPartner (state, contractPartner) {
    state.contractPartner = contractPartner
  },
  updateContractPartnerName (state, contractPartnerName) {
    state.contractPartner.contractPartnerName = contractPartnerName
  },
  updateDomain (state, domain) {
    state.contractPartner.domain = domain
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contractPartners.js